import { computed, reactive, watch } from "vue";

import { theme } from "config";

// Helpers for the theme, like phonenumer formatting or logo path
// Helpers for the theme, like phonenumer formatting or logo path
// Helpers for the theme, like phonenumer formatting or logo path

const logoData = reactive({
	svg: ""
})
export const logo_path = (name = "logo") => {
	return computed(
		() => `/images/${theme("subfolder")}/${name}.${theme("logo_extension")}`
	).value;
};
watch(
	() => theme("logo_extension"),
	() => {
		if (theme("logo_extension") === "svg") {
			fetch(logo_path("logo")).then(response => response.text()).then(data => {
				logoData.svg = data;
			});
		}
	},
	{ immediate: true }
);
export const logo_extension = (name = "logo") => {
	return computed(
		() => theme("logo_extension")
	).value;
};
export const logo = (name = "logo") => {
	// <img class="logo" :src="logo_path()" :alt="theme('title')">
	return computed(() => {
		if (theme("logo_extension") === "svg") {
			// Get the SVG content
			return logoData.svg ?? "";
		}
		return `<img class="logo" src="${logo_path(name)}" alt="${theme("title")}">`;
	}).value;
};

export const phonenumber = (number) => {
	number = number.replace(/^\+/, '00');
	return number.replace(/\D/g, '');
};


export const abbreviation = (name) => {
	return computed(() => {
		const result = {
			letter: "",
			color: ""
		};

		// Fallback
		if (!name) return result;

		result.letter = name.charAt(0,1).toUpperCase();

		// Based on letter, output a color
		const colors = [
			"#FF5733", "#33FF57", "#3357FF", "#FF33A1", "#A133FF",
			"#33FFF3", "#FFC133", "#FF3333", "#33FF33", "#3333FF",
		];
		// Determine the color index based on the ASCII value of the letter
		const colorIndex = result.letter.charCodeAt(0) % colors.length;
		result.color = colors[colorIndex];

		// Change to rgb values
		const hex = result.color.replace("#", "");
		result.color = `${parseInt(hex.substring(0, 2), 16)}, ${parseInt(hex.substring(2, 4), 16)}, ${parseInt(hex.substring(4, 6), 16)}`;

		return result;

	}).value;
};